module.exports = __webpack_public_path__ + "media/images/new/icons/heart-275cee022c4f59f09ff9d5acf196fea9.png";